var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "report-menu" },
    _vm._l(_vm.menuItems, function (item) {
      return _c(
        "div",
        {
          key: item.tab,
          staticClass: "menu-item",
          class: { active: _vm.currentTab === item.tab },
          on: {
            click: function ($event) {
              return _vm.updateQueryParams("report", item.tab)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "menu-item-icon", class: item.iconClass },
            [
              item.component
                ? _c(
                    item.component,
                    _vm._b(
                      { tag: "component" },
                      "component",
                      item.componentProps,
                      false
                    )
                  )
                : _c("i", { staticClass: "material-icons" }, [
                    _vm._v(_vm._s(item.icon)),
                  ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "menu-item-label" }, [
            _vm._v(_vm._s(item.label)),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }